import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameProgressReducer from './reducers/gameProgressReducer';
import roundPlayReducer from './reducers/roundPlayReducer';
import alexReducer from './reducers/alexReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameProgress: gameProgressReducer,
  roundPlay: roundPlayReducer,
  alex: alexReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
